import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {HtmlBlock} from '../../../../../models/page-content';
import {firstValueFrom} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../../../../services/api-agent.service';
// import {TagPicker} from 'rsuite';
// import Choices from 'choices.js';
import {GlobalLoaderService} from '../../../../../services/global-loader.service';
import {CommonModule} from '@angular/common';

declare var Tagify: any;
declare var jscolor: any;
declare var $: any;
declare var tinymce: any;

const CONSOLE_PREFIX = 'htmlBlocks form';

// noinspection DuplicatedCode
@Component({
  selector: 'app-html-content',
  templateUrl: './html-content.component.html',
  styleUrl: './html-content.component.scss',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  encapsulation: ViewEncapsulation.None
})
export class HtmlContentComponent implements OnInit, OnChanges {
  editorTrackers = new Map();
  htmlBlockForm: FormGroup;
  @Input() initialData: HtmlBlock[];
  nextUid = 0;
  productLabels = [];

  constructor(private fb: FormBuilder,
              private loader: GlobalLoaderService,
              private translate: TranslateService,
              private api: ApiAgentService) {
  }

  handleImageUpload(blobInfo) {
    const base64str = 'data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64();
    console.log(CONSOLE_PREFIX + '(handleImageUpload) - base64str', base64str);
    return Promise.resolve(base64str);
  }

  async ngOnInit(): Promise<void> {
    this.htmlBlockForm = this.fb.group({
      htmlBlocks: this.fb.array([])
    });
    await this.loadResources();
  }

  async loadResources() {
    await this.loader.loadExternalStyles('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@yaireo/tagify');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@yaireo/tagify/dist/tagify.polyfills.min.js');
    await this.loader.loadExternalStyles('https://cdn.jsdelivr.net/npm/@yaireo/tagify/dist/tagify.css');
  }

  async moveUp(uid) {
    console.log(CONSOLE_PREFIX + '(moveUp) - uid', uid);
    const index = this.htmlBlocks.value.findIndex(block => block.uid === uid);
    if (index > 0) {
      const currentBlock = this.htmlBlocks.at(index);
      this.htmlBlocks.removeAt(index);
      this.htmlBlocks.insert(index - 1, currentBlock);

      this.refreshBlocks(this.htmlBlocks.value);
    }
  }

  async moveDown(uid) {
    console.log(CONSOLE_PREFIX + '(moveDown) - uid', uid);
    const index = this.htmlBlocks.value.findIndex(block => block.uid === uid);
    if (index < this.htmlBlocks.length - 1) {
      const currentBlock = this.htmlBlocks.at(index);
      this.htmlBlocks.removeAt(index);
      this.htmlBlocks.insert(index + 1, currentBlock);

      this.refreshBlocks(this.htmlBlocks.value);
    }
  }


  private refreshBlocks(data: HtmlBlock[]) {
    console.log(CONSOLE_PREFIX + '(refreshBlocks) - data', data);
    this.populateForm(data);
  }

  populateForm(data: HtmlBlock[]): void {
    console.log(CONSOLE_PREFIX + '(populateForm) - data', data);
    console.log(CONSOLE_PREFIX + '(populateForm) - htmlBlocks', this.htmlBlocks);
    console.log(CONSOLE_PREFIX + '(populateForm) - htmlBlocks.length', this.htmlBlocks.length);
    while (this.htmlBlocks && this.htmlBlocks.length !== 0) {
      this.htmlBlocks.removeAt(0);
    }
    setTimeout(() => {
      data.forEach(async htmlBlockData => {
        console.log(CONSOLE_PREFIX + '(populateForm) - htmlBlockData', htmlBlockData);
        // if (htmlBlockData.content) {
        console.log(CONSOLE_PREFIX + '(populateForm) - populating htmlBlockData', htmlBlockData);
        if (htmlBlockData.type === 'products') {
          this.htmlBlocks.push(await this.createProductBlock('populateForm', htmlBlockData));
        } else {
          this.htmlBlocks.push(await this.createHtmlBlock('populateForm', htmlBlockData));
        }
        // }
      });
    }, 100);
  }

  async loadTagifyTags(data: HtmlBlock, uid) {
    let choices = this.productLabels;
    console.log(CONSOLE_PREFIX + '(loadChoiceTags) - data', data);
    console.log(CONSOLE_PREFIX + '(loadChoiceTags) - choices', choices);
    let htmlId = 'html_' + uid;
    console.log(CONSOLE_PREFIX + '(loadChoiceTags) - html', htmlId);

    // map choices to get
    setTimeout(() => {
      let nativeElement = document.getElementById(htmlId);
      console.log(CONSOLE_PREFIX + '(loadChoiceTags) - nativeElement', nativeElement);
      let tagify = new Tagify(nativeElement, {
        whitelist: choices,
        dropdown: {
          mapValueTo: 'full',
          classname: 'tagify__dropdown--rtl-example',
          enabled: 0, // shows the suggestiosn dropdown once field is focused
          RTL: true,
          escapeHTML: false // allows HTML inside each suggestion item
        },
        callbacks: {
          'add': (e) => {
            console.log(CONSOLE_PREFIX + '(loadChoiceTags) - add', e);
            let data = e.detail.tagify.value;
            this.updateHtmlBlockFormValue(uid, data);
          },
          'remove': (e) => {
            console.log(CONSOLE_PREFIX + '(loadChoiceTags) - remove', e);
            let data = e.detail.tagify.value;
            this.updateHtmlBlockFormValue(uid, data);
          },
          'input': (e) => {
            console.log(CONSOLE_PREFIX + '(loadChoiceTags) - input', e);
          }
        }
      });

      tagify.addTags(data.content);
      this.editorTrackers.set(uid, {htmlId: htmlId, type: data.type, editor: tagify});
      console.log(CONSOLE_PREFIX + '(loadChoiceTags) - editorTrackers', this.editorTrackers);
    }, 100);
  }

  async loadTinyCME(data: HtmlBlock, uid) {
    console.log(CONSOLE_PREFIX + '(loadCkEditor) - data', data);
    let txt = await firstValueFrom(this.translate.get('Compose the page content'));
    let lang = await firstValueFrom(this.translate.get('lang'));
    console.log(CONSOLE_PREFIX + '(loadCkEditor) - txt', txt);
    let htmlId = '#html_' + uid;
    console.log(CONSOLE_PREFIX + '(loadCkEditor) - html', htmlId);

    setTimeout(() => {
      tinymce.init({
        selector: htmlId,
        // plugins: 'tinycomments mentions anchor autolink charmap codesample emoticons image code link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed permanentpen footnotes advtemplate advtable advcode editimage tableofcontents mergetags powerpaste tinymcespellchecker autocorrect a11ychecker typography inlinecss',
        plugins: 'directionality tinycomments mentions anchor autolink charmap codesample emoticons image imagetools code link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export',
        // toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image code media table mergetags | align lineheight | tinycomments | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
        toolbar: 'undo redo | ltr rtl | blocks fontfamily fontsize | bold italic underline strikethrough | link image code media table mergetags | align lineheight | tinycomments | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
        language: lang,
        tinycomments_mode: 'embedded',
        image_uploadtab: true,
        content_langs: [
          {title: 'English', code: 'en'},
          {title: 'عربي', code: 'ar'}
        ],
        images_file_types: 'jpeg,jpg',
        images_upload_handler: this.handleImageUpload,
        setup: (editor) => {
          editor.on('change', () => {
            const content = editor.getContent();
            this.updateHtmlBlockFormValue(uid, content);
          });
        }, init_instance_callback: (editor) => {
          if (data.content) {
            editor.setContent(data.content);
          }
        }
      });
      this.editorTrackers.set(uid, {htmlId: htmlId, type: data.type});
      setTimeout(() => {
        $('.tox-promotion').css('display', 'none');
        $('.tox-statusbar__branding').css('display', 'none');
      }, 1000);
    }, 100);
  }


  updateHtmlBlockFormValue(uid, content) {
    console.log(CONSOLE_PREFIX + '(updateHtmlBlockFormValue) - uid', uid);
    console.log(CONSOLE_PREFIX + '(updateHtmlBlockFormValue) - content', content);
    // Find the form group for the given UID and update its 'html' value
    const index = this.htmlBlocks.controls.findIndex(block => block.value.uid === uid);
    if (index !== -1) {
      const htmlBlock = this.htmlBlocks.at(index);
      htmlBlock.get('content').setValue(content, {emitEvent: false}); // Prevent loop of events
    }
  }

  async createProductBlock(referrer, data: HtmlBlock = {
    content: '',
    type: 'products',
    backgroundColor: '#FFFFFFFF',
    uid: 0
  }): Promise<FormGroup> {
    const uid = this.nextUid++;

    console.log(CONSOLE_PREFIX + '(createProductBlock) - uid', uid);
    console.log(CONSOLE_PREFIX + '(createProductBlock) - referrer', referrer);

    await this.loadProductsLabels();
    data.choices = this.productLabels;
    console.log(CONSOLE_PREFIX + '(createProductBlock) - data', data);
    await this.loadTagifyTags(data, uid);

    setTimeout(() => {
      jscolor.install(); // recognizes new inputs and installs jscolor on them
      console.log(CONSOLE_PREFIX + '(createProductBlock) - jscolor install', jscolor.install);
    }, 1000);

    return this.fb.group({
      uid: [uid],
      content: [data.content || '', Validators.required],
      type: [data.type],
      choices: [data.choices || []],
      title: [data.title || ''],
      titleColor: [data.titleColor || '#000000FF'],
      backgroundColor: [data.backgroundColor || '#FFFFFFFF']
    });
  }

  async createHtmlBlock(referrer, data: HtmlBlock = {
    content: '',
    type: 'html',
    backgroundColor: '#FFFFFFFF',
    uid: 0
  }): Promise<FormGroup> {
    const uid = this.nextUid++;
    console.log(CONSOLE_PREFIX + '(createHtmlBlock) - uid', uid);
    console.log(CONSOLE_PREFIX + '(createHtmlBlock) - referrer', referrer);
    setTimeout(async () => {
      jscolor.install(); // recognizes new inputs and installs jscolor on them
      console.log(CONSOLE_PREFIX + '(createHtmlBlock) - jscolor install', jscolor.install);
      await this.loadTinyCME(data, uid);
    }, 100);

    console.log(CONSOLE_PREFIX + '(createHtmlBlock) - data', data);

    return this.fb.group({
      uid: [uid],
      content: [data.content || '', Validators.required],
      type: [data.type],
      backgroundColor: [data.backgroundColor || '#FFFFFFFF'],
      choices: [data.choices || []]
    });
  }

  ngAfterViewInit() {
    jscolor.init();
    console.log(CONSOLE_PREFIX + '(ngAfterViewInit) - jscolor init', jscolor.init);
  }

  // @ts-ignore
  get htmlBlocks(): FormArray {
    // @ts-ignore
    return this.htmlBlockForm != null && this.htmlBlockForm.get('htmlBlocks') != null ? this.htmlBlockForm.get('htmlBlocks') as FormArray : [];
  }

  async addHtmlBlock(): Promise<void> {
    console.log(CONSOLE_PREFIX + '(addHtmlBlock) - this.htmlBlocks.length', this.htmlBlocks.length);
    this.htmlBlocks.push(await this.createHtmlBlock('addHtmlBlock event'));
  }

  removeHtmlBlock(uid: number): void {
    const index = this.htmlBlocks.value.findIndex(block => block.uid === uid);
    if (index > -1) {
      this.htmlBlocks.removeAt(index);
      this.editorTrackers.delete(uid);
    }
  }

  async addProductsBlock(): Promise<void> {
    console.log(CONSOLE_PREFIX + '(addProductsBlock) - this.htmlBlocks.length', this.htmlBlocks.length);
    this.htmlBlocks.push(await this.createProductBlock('addProductsBlock event'));
  }

  onSubmit(): void {
    if (this.htmlBlockForm.valid) {
      console.log(CONSOLE_PREFIX + '(onSubmit) - this.htmlBlockForm.value', this.htmlBlockForm.value);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(CONSOLE_PREFIX + '(ngOnChanges) - changes', changes);
    if (changes.initialData) {
      this.populateForm(changes.initialData.currentValue);
    }
  }

  private async loadProductsLabels() {
    if (this.productLabels.length === 0) {
      this.productLabels = [
        {value: 'all', full: 'All - الكل'},
      ];
      try {
        let collections = await this.api.loadCollections();
        console.log(CONSOLE_PREFIX + '(loadProductsLabels) - collections', collections);
        collections.forEach(collection => {
          this.productLabels.push({
            value: collection.id + '-' + collection.name + '-' + collection.name_locale.ar,
            full: collection.name + ' - ' + collection.name_locale.ar
          });
        });
      } catch (ex) {
      }
    }
    console.log(CONSOLE_PREFIX + '(loadProductsLabels) - productLabels', this.productLabels);
  }

}
